import { Action } from 'redux';
import { BasketActionTypes } from '../basket.types';
import { ACTION_CREATOR_NAME } from 'helpers';

export interface SetShowReservationWarningAction extends Action<BasketActionTypes.SET_SHOW_RESERVATION_WARNING>{
    shouldShowReservationWarning: boolean;
}

export const setShowReservationWarning: (showReservationWarning: boolean) => SetShowReservationWarningAction = (showReservationWarning: boolean) => ({
    type: BasketActionTypes.SET_SHOW_RESERVATION_WARNING,
    shouldShowReservationWarning: showReservationWarning
});
setShowReservationWarning[ACTION_CREATOR_NAME] = 'setShowReservationWarning';

export type SetShowReservationWarningFunc = (...args: Parameters<typeof setShowReservationWarning>) => void;